import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	errorPrimary: {
		id: 'dynamic-cards-search-page.error_primary',
		defaultMessage: "We're having trouble searching",
		description: 'Message shown when search request fails',
	},
	errorSecondary: {
		id: 'dynamic-cards-search-page.error_secondary',
		defaultMessage: 'It might just be a hiccup. The best thing to do is to <btn>try again</btn>.',
		description: 'Additional message to prompt users to try again',
	},
});
